module.exports = __webpack_public_path__ + "img/paper.428ef634.svg";